import { createAction, createAsyncAction } from 'typesafe-actions';
import { TaskInfo, GetTasksParams, TaskModalType, UpdateTaskPayload, CreateTaskPayload } from './types';

export const getTasksAsync = createAsyncAction(
  'tasks/GET_TASKS_REQUEST',
  'tasks/GET_TASKS_SUCCESS',
  'tasks/GET_TASKS_FAILURE',
)<GetTasksParams, { total: number; tasks: any[] }, Error>();

export const updateTaskAsync = createAsyncAction(
  'tasks/UPDATE_TASK_REQUEST',
  'tasks/UPDATE_TASK_SUCCESS',
  'tasks/UPDATE_TASK_FAILURE',
)<UpdateTaskPayload, {}, Error>();

export const addTaskAsync = createAsyncAction(
  'tasks/ADD_TASK_REQUEST',
  'tasks/ADD_TASK_SUCCESS',
  'tasks/ADD_TASK_FAILURE',
)<CreateTaskPayload, {}, Error>();

export const deleteTaskAsync = createAsyncAction(
  'tasks/DELETE_TASK_REQUEST',
  'tasks/DELETE_TASK_SUCCESS',
  'tasks/DELETE_TASK_FAILURE',
)<{}, {}, Error>();

export const setTasks = createAction('tasks/SET_TASKS')<Array<TaskInfo>>();
export const setTaskModalType = createAction('tasks/SET_TASK_MODAL_TYPE')<TaskModalType>();
export const setSelectedTask = createAction('tasks/SET_SELECTED_TASK')<TaskInfo>();
export const setRefreshTable = createAction('tasks/SET_REFRESH_TABLE')<boolean>();
